import { render } from "./BackupPage.vue?vue&type=template&id=2a24f729&scoped=true&ts=true"
import script from "./BackupPage.vue?vue&type=script&lang=ts"
export * from "./BackupPage.vue?vue&type=script&lang=ts"

import "./BackupPage.vue?vue&type=style&index=0&id=2a24f729&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a24f729"]])

export default __exports__